import React from 'react'

// Import typefaces
import 'typeface-montserrat'
import 'typeface-merriweather'

import profilePic from './profile-pic.jpg'
import { rhythm } from '../utils/typography'

class Bio extends React.Component {
  render() {
    return (
      <div
        style={{
          display: 'flex',
          marginBottom: rhythm(2.5),
        }}
      >
        <img
          src={profilePic}
          alt={`Gabriel Ricard`}
          style={{
            marginRight: rhythm(1 / 2),
            marginBottom: 0,
            width: rhythm(2),
            height: rhythm(2),
          }}
        />
        <p>
          Stream of consciousness software fuckery.<br />
          Assembled by <strong>Gabriel Ricard</strong>, software developer, runner, dad, dude &amp; occasional grumpy-pants.{' '}
          Bother me on{' '}
          <a href="https://twitter.com/gabericard">Twitter</a> &amp;{' '}
          <a href="https://github.com/gricard">GitHub</a> if you feel like it.
        </p>
      </div>
    )
  }
}

export default Bio
